import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DOC_CONFIG } from 'src/app/doc.config';
import { API_CONFIG } from 'src/app/api.config';

@Injectable({
  providedIn: 'root'
})
export class S8AccessService {
  arrCalls: string[];
  status: Object;
  status_sala: Object;
  status_principal: Object;
  status_catraca: Object;

  public static httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  public getHeaders() {
    let headers = new HttpHeaders();
    return headers;
  }

  private apiUrl = `${API_CONFIG.baseUrl}/acesso-s8`;
  constructor(private httpService: HttpClient) { }

  getAccess(): Observable<any> {
    return this.httpService.get<any>(this.apiUrl);
  }

  updateStatus(id: number): void {
    this.httpService.put<any>(`${API_CONFIG.baseUrl}/acesso-pgeral/status-sala/` + id, { headers: this.getHeaders() }).subscribe(data => {
      this.status_sala = {
        "status_sala": 1
      }
    });
  }
}

